import React from 'react'

export default (props) => (
    <svg width="38" height="42" viewBox="0 0 38 42" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M6.49999 27.0622C1.83333 24.3679 1.83333 17.6321 6.5 14.9378L24.5 4.54552C29.1667 1.85122 35 5.21909 35 10.6077L35 31.3923C35 36.7809 29.1667 40.1488 24.5 37.4545L6.49999 27.0622Z" stroke="white" strokeWidth="6"/>
    </svg>
);

